import React, { useState, useContext, useEffect, useMemo } from 'react';

import {
  Row, Col,
  Divider,
  Button,
  Menu,
  Tag,
  Form, Input, Select, DatePicker, InputNumber, Modal,
  Space, Dropdown, Popover, Tooltip
} from 'antd';
import moment from 'moment';
import {
  ExclamationCircleOutlined,
  FormOutlined,
  CloseOutlined,
  SaveOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
  FileExcelOutlined,
  DatabaseOutlined,
  CaretDownOutlined,
  EditOutlined
} from '@ant-design/icons';

import { toThousands, toFixed2 } from '../../utils/Numeric';
import { Loadding, Page } from '../../components';
import { MasterContext } from '../../App';
import { OrderContext } from './';
import { getStatYear, getGoodsList, getGoodsListByDatetime, getGoodsSpecPriceList } from '../../services/Buyer';
import { deleteSelfPackagePallet, getListOrderGoods } from '../../services/Order';
import { getDatetime } from '../../services/Login';
import { default as GoodsImport } from './goodsImport';
import './style';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import goods from '../buyer/goods';
import { EllipseCurve } from 'three';

const { RangePicker } = DatePicker;
export default React.forwardRef((props, ref) => {
  const { company, port, transport, user, currency, payment, shipmark, currentUser, authorities, currency_rate } = useContext(MasterContext);
  const { buyers } = useContext(OrderContext);
  const { mode, order, orderGoods, downloadOrder, setShowGoodsSelect, onCloseCallback, onSaveCallback } = props;
  const [selectedGoods, setSelectedGoods] = useState(orderGoods.length === 0 ? [{ count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, count: 0, subcount: [0] }] : JSON.parse(JSON.stringify(orderGoods)));
  const [form] = Form.useForm();
  const [remark, setRemark] = useState(order ? order.remark : undefined);
  const [headerDesc, setHeaderDesc] = useState(order ? order.header_desc : undefined);
  const [footerDesc, setFooterDesc] = useState(order ? order.footer_desc : undefined);
  const [transportId, setTransportId] = useState(order ? order.transport_id : undefined);
  const [selectedLoadingPortId, setSelectedLoadingPortId] = useState(order ? order.loading_port_id : undefined);
  const [selectedCompanyId, setSelectedCompanyId] = useState(order ? order.company_id : undefined);
  const [poCode, setPoCode] = useState(order ? order.po_code : undefined);
  const [selectedBuyerId, setSelectedBuyerId] = useState(order ? order.buyer_id : undefined);
  const [selectedPaymentId, setSelectedPaymentId] = useState(order ? order.payment_id : undefined);
  const [selectedOwnerId, setSelectedOwnerId] = useState(order ? order.owner_id : undefined);

  const [selectedDestinationPortId, setSelectedDestinationPortId] = useState(order ? order.destination_port_id : undefined);
  const [buyerStatYear, setBuyerStatYear] = useState({ pending: 0, completed: 0, amount: 0 });
  const [isShowGoodsImport, setShowGoodsImport] = useState(false);
  const [isReadonly, setReadonly] = useState(false);

  const [shippingMark, setShippingMark] = useState(order ? order.shipmark : shipmark[0].name);
  const [shippingWith, setShippingWith] = useState(order ? order.shipwith : undefined);

  const [selectedBuyerGoods, setSelectedBuyerGoods] = useState([]);
  const [goodsCode, setGoodsCode] = useState(order ? order.goods_code : undefined);

  const [isAsap, setAsap] = useState(order ? order.is_asap : false);
  const [isPreAdd, setPreAdd] = useState(order ? order.is_pre_add : false);
  const [jiduYear, setJiduYear] = useState(order ? order.jidu_year : new Date().getFullYear());
  const selectedBuyer = buyers.find(x => x.id === selectedBuyerId) || {};
  const [pagination, setPagination] = useState({ limit: 10, offset: 0 });
  const [page, setPage] = useState(0);
  const [period, setPeriod] = useState(
    [order ? moment(order.date, 'YYYY-MM-DD') : undefined,
    order ? moment(order.delivery_deadline_date, 'YYYY-MM-DD') : undefined]);

  const [orderDatetime, setOrderDatetime] = useState(order ? order.datetime : undefined);
  let [isStart, setStart] = useState(false);
  let [isEnd, setEnd] = useState(false)
  const [type, setType] = useState(order ? order.type : 1);

  const [currentRowIndex, setCurrentRowIndex] = useState(-1);

  const avalidGoods = selectedGoods.filter(x => !x.deleted);
  ////////////////////////////////////////////////////////
  const [importMode, setImportMode] = useState(0);
  const checkCount = (goods) => {
    if (mode === 'new' && type === 1) {
      return true;
    }
    if (mode === 'new' && type !== 1) {
      if (goods.count === (isPreAdd ? goods.count_add : 0) + goods.count_mon1 + goods.count_mon2 + goods.count_mon3) {
        return true;
      } else {
        return false;
      }
    }

    if (mode === 'edit' && type === 1) {
      if (goods.count === sumSubcount(goods.subcount)) {
        return true;
      } else {
        return false;
      }
    }
    if (mode === 'edit' && type !== 1) {
      if (goods.count === (isPreAdd ? goods.count_add : 0) + goods.count_mon1 + goods.count_mon2 + goods.count_mon3 + sumSubcount(goods.subcount)) {
        return true;
      } else {
        return false;
      }
    }
  }

  const backgroundColor2 = (goods, count, i) => {
    //const find = selectedBuyerGoods.find(x => x.goods_spec_id === goods.goods_spec_id);
    if (goods.pcs_per_carton && (count % goods.pcs_per_carton !== 0)) {
      goods['error' + i] = '每箱标准：' + goods.pcs_per_carton + '件';
      return 'red';
    }
    goods['error' + i] = undefined;
    return '#FFD700';
  }

  const backgroundColor = (goods) => {
    if (checkCount(goods)) {
      // const find = selectedBuyerGoods.find(x => x.goods_spec_id === goods.goods_spec_id);
      if (goods.pcs_per_carton && (goods.count % goods.pcs_per_carton !== 0)) {
        goods.error = '每箱标准：' + goods.pcs_per_carton + '件';
        return 'red';
      }
      goods.error = undefined;
      return '#FFD700';
    } else {
      goods.error = '总数量不正确';
      return 'red';
    }
  }

  const onGoodsChangeSubCount = (value, i, ii) => {
    const temp = [].concat(selectedGoods);
    temp[i].subcount[ii] = value;
    setSelectedGoods(temp);
  }

  const deleteAddCol = (i) => {
    Modal.confirm({
      title: `删除确认`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{`确定删除当前订单中的添加列${i + 1}吗?`}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const temp = [].concat(selectedGoods);
        temp.forEach(x => {
          if (x.subcount) { x.subcount.splice(i, 1); };
        });
        recalcSum(temp);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleImport = (item) => {
    const key = parseInt(item.key);
    if (key === 0 || key === 1) {
      setImportMode(key);
      setShowGoodsImport(true);
    } else {
      const temp = [].concat(selectedGoods);
      temp.forEach(x => {
        if (!x.subcount) { x.subcount = [] };
        x.subcount.push(0);
      });
      temp.forEach((x, i) => {
        x.i = i;
      })
      setSelectedGoods(temp);
    }
  }
  const sumSubcount = (subcount) => {
    let sum = 0;
    (subcount || []).forEach(x => {
      sum += x;
    });
    return sum;
  }

  ////////////////////////////////////////////////////////
  const [isShowEditPrice, setShowEditPrice] = useState(false);
  const [priceList, setPriceList] = useState([]);
  const [isPriceListLoading, setPriceListLoading] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(undefined);
  const [selectedEditPriceGoods, setSelectedEditPriceGoods] = useState({});

  const onEditPriceOK = () => {
    if (!selectedPrice) return undefined;
    const temp = [].concat(selectedGoods);
    const find = temp.find(x => x.id === selectedEditPriceGoods.id);
    if (find) {
      find.price_start_time = selectedPrice.start_time;
      find.price = selectedPrice.price;
      setSelectedGoods(temp);
    }
    setShowEditPrice(false);
  }

  const onChangeEditPrice = (start_time) => {
    const find = priceList.find(x =>
      x.buyer_id === selectedBuyerId &&
      x.goods_id === selectedEditPriceGoods.goods_id &&
      x.goods_spec_id === selectedEditPriceGoods.goods_spec_id &&
      x.start_time === start_time
    );
    setSelectedPrice(find);
  }
  const onEditPrice = (goods) => {
    if (!selectedBuyerId) return undefined;

    setPriceListLoading(true);
    getGoodsSpecPriceList(selectedBuyerId, goods.goods_id, goods.goods_spec_id).then(data => {
      setPriceList(data);
      setPriceListLoading(false);
      setSelectedEditPriceGoods(goods);
      setShowEditPrice(true);
    });
  }

  const editPrice = (goods) => {
    if (currentUser.category_id !== 1 && !authorities.find(x => x === 'edit_order_price')) {
      return undefined;
    }
    if (mode !== 'edit' || isReadonly) return undefined;
    if (!selectedBuyerId) return undefined;

    return <a><EditOutlined onClick={() => onEditPrice(goods)} /></a>
  }
  const editPriceBody = () => {
    return <div style={{ padding: '1rem' }}>
      <div>历史价格列表：</div>
      {
        isPriceListLoading && <Loadding />
      }
      {
        !isPriceListLoading && <Select onChange={onChangeEditPrice} style={{ width: '100%' }}>
          {
            priceList.map(x => (
              <Select.Option key={x.start_time} value={x.start_time}>{x.start_time} - [<strong>{x.price}</strong>]</Select.Option>
            ))
          }
        </Select>
      }
      <div style={{ padding: '1rem 0', display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => setShowEditPrice(false)}>取 消</Button>
        &nbsp;&nbsp;&nbsp;
        <Button disabled={!selectedPrice} onClick={onEditPriceOK} type="primary">确 定</Button>
      </div>
    </div>
  }
  /////////////////////////////////////////////////////////

  const onPrePage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  }
  const onNextPage = () => {

    const pageCount = Math.ceil(avalidGoods.length / pagination.limit);
    if (page < pageCount - 1) {
      setPage(page + 1);
    }
  }
  const onChangePagination = (value) => {
    setPagination({ limit: value, offset: 0 });
    setPage(0);
  }

  const recalcSum = (temp) => {
    Modal.confirm({
      title: `自动计算确认`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{`数量有变化，总数量是否进行自动计算?`}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        if (type === 1) {
          temp.forEach(x => {
            x.count = 0;
            x.subcount.forEach(y => {
              x.count += y;
            })
          });
        } else {
          temp.forEach(x => {
            x.count = 0;
            x.subcount.forEach(y => {
              x.count += y;
            });
            if (isPreAdd) {
              x.count += x.count_add;
            }
            x.count += x.count_mon1;
            x.count += x.count_mon2;
            x.count += x.count_mon3;
          })
        }
        setSelectedGoods(temp);
      },
      onCancel() {
        setSelectedGoods(temp);
        console.log('Cancel');
      },
    });
  }
  const onImportOrderGoods = (goods, callback) => {
    let temp = [].concat(selectedGoods);
    if (importMode === 0) {
      if (mode === 'new') {
        temp = [];
      }
      temp.forEach((x, i) => {
        x.deleted = true;
        if (type === 1) {
          x.subcount = [x.count];
        } else {
          x.subcount = [];
        }
      });
      goods.forEach((x, i) => {
        if (type === 1) {
          temp.push(Object.assign({}, x, { subcount: [x.count] }))
        } else {
          temp.push(Object.assign({}, x, { subcount: [] }))
        }
      })
      temp.forEach((x, i) => {
        x.i = i;
      })
      setSelectedGoods(temp);
      if (temp.length > 200) {
        const temp = Object.assign(pagination);
        if (temp.limit < 20) {
          setPagination({ limit: 20, offset: page * 20 });
        }
      }
      callback && callback();
      return;
    }

    if (importMode === 1) {
      temp.forEach(x => {
        if (!x.subcount) x.subcount = [];
        const find = goods.find(y => y.goods_spec_name === x.goods_spec_name);
        if (find) {
          x.subcount.push(find.count);
        } else {
          x.subcount.push(0);
        }
      });
      goods.forEach(x => {
        const find = temp.find(y => y.goods_spec_name === x.goods_spec_name);
        if (!find) {
          x.subcount = [];
          const first = temp[0].subcount;
          first.forEach(() => {
            x.subcount.push(0);
          });
          x.subcount[x.subcount.length - 1] = x.count;
          temp.push(x);
        }
      });
      temp.forEach((x, i) => {
        x.i = i;
      })
      recalcSum(temp);
      callback && callback();
    }
  }

  const onKeyDown = (e) => {
    switch (e.keyCode) {
      case 37:
        if (e.target.selectionStart === 0) {
          isStart = true;
        } else {
          isStart = false;
        }
        break;
      case 38:
        e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
        e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
        break;
      case 39:
        if (e.target.selectionEnd === e.target.value.length) {
          isEnd = true;
        } else {
          isEnd = false;
        }
        break;
      case 40:
        e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
        e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
        break;
    }
  }

  const onKeyUp = (e) => {
    e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
    e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
    switch (e.keyCode) {
      case 37: {
        const idx = e.target.id.split('-');
        if (idx[0] === 'or') {
          if (isStart) {
            const ele = document.getElementById('on-' + idx[1]);
            if (ele) ele.focus();
            setStart(false);
          }
        } else {

        }

      }
        break;
      case 38: {
        const idx = e.target.id.split('-');
        const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) - 1));
        if (ele) ele.focus();
      }
        break;
      case 39: {
        const idx = e.target.id.split('-');
        if (idx[0] === 'on') {
          if (isEnd) {
            const ele = document.getElementById('or-' + idx[1]);
            if (ele) ele.focus();
            setEnd(false);
          }
        } else {

        }

      }
        break;
      case 40: {
        const idx = e.target.id.split('-');
        const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) + 1));
        if (ele) ele.focus();
      }
        break;
    }
  }

  const onPressEnter = (e) => {
    e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
    e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
    const idx = e.target.id.split('-');
    if (idx.length !== 2) return false;
    const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) + 1));
    if (!ele) {
      for (let i = 0; i < parseInt(idx[1]); i++) {
        const ele = document.getElementById(idx[0] + '-' + i);
        if (ele) {
          ele.focus();
          break;
        }
      }
    } else {
      ele.focus();
    }
    return false;
  }

  useEffect(() => {
    const temp = Object.assign(pagination);
    setPagination({ limit: temp.limit, offset: page * temp.limit });
  }, [page])

  const onMenuDownload = (e) => {
    downloadOrder(order, e.key);
  }

  const downloadMenu = (
    <Menu onClick={onMenuDownload}>
      {type === 1 && <Menu.Item key="1">单页模板</Menu.Item>}
      {type === 1 && <Menu.Item key="4">单页模板[含重量]</Menu.Item>}
      {type === 1 && <Menu.Item key="2">双页模板[附件]</Menu.Item>}
      {(type === 21 || type === 22 || type === 23 || type === 24) && <Menu.Item key="3">季度单模板</Menu.Item>}
    </Menu>
  );

  const getBuyerGoods = (callback) => {
    if (selectedBuyer.id) {
      if (mode === 'edit') {
        getGoodsListByDatetime(selectedBuyer.id, orderDatetime).then(data => {
          setSelectedBuyerGoods(data);
          callback && callback();
        });
      } else {
        getDatetime().then(data => {
          setOrderDatetime(data);
          getGoodsListByDatetime(selectedBuyer.id, data).then(data => {
            setSelectedBuyerGoods(data);
            callback && callback();
          });
        });
      }

    }
  }

  const onGoodsChangeSpec = (goods_spec_id, i) => {
    const buyerGoods = selectedBuyerGoods.find(x => x.goods_spec_id === goods_spec_id);
    const temp = [].concat(selectedGoods);
    temp[i].goods_id = buyerGoods.goods_id;
    temp[i].goods_name = buyerGoods.goods_name;
    temp[i].size = buyerGoods.size;
    temp[i].goods_spec_id = goods_spec_id;
    temp[i].price_start_time = buyerGoods.start_time;
    temp[i].price = buyerGoods.price;
    temp[i].pcs_per_carton = buyerGoods.pcs_per_carton;
    temp[i].carton_count_per_pallet = buyerGoods.carton_count_per_pallet;
    temp[i].subcount = [];
    setSelectedGoods(temp);
  }

  const onGoodsChangeCountAdd = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].count_add = value;
    temp[i].count = value + (temp[i].count_mon1 || 0) + (temp[i].count_mon2 || 0) + (temp[i].count_mon3 || 0)
    setSelectedGoods(temp);
  }

  const onGoodsChangeCountMon1 = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].count_mon1 = value;
    temp[i].count = value + (temp[i].count_add || 0) + (temp[i].count_mon2 || 0) + (temp[i].count_mon3 || 0)
    setSelectedGoods(temp);
  }

  const onGoodsChangeCountMon2 = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].count_mon2 = value;
    temp[i].count = value + (temp[i].count_mon1 || 0) + (temp[i].count_add || 0) + (temp[i].count_mon3 || 0)
    setSelectedGoods(temp);
  }

  const onGoodsChangeCountMon3 = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].count_mon3 = value;
    temp[i].count = value + (temp[i].count_mon1 || 0) + (temp[i].count_mon2 || 0) + (temp[i].count_add || 0)
    setSelectedGoods(temp);
  }

  const onGoodsChangeCount = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].count = value;
    if (type === 1) {
      if (!temp[i].subcount) {
        temp[i].subcount = [0];
      }
      if (temp[i].subcount.length < 2) {
        temp[i].subcount[0] = value;
      }
    }
    setSelectedGoods(temp);
  }

  const onGoodsChangeRemark = (value, i) => {
    if (i >= selectedGoods.length) return;
    const temp = [].concat(selectedGoods);
    temp[i].remark = value;
    setSelectedGoods(temp);
  }

  const onAddGoods = (i) => {
    const temp = [].concat(selectedGoods);
    const subcount = [];
    temp[0].subcount.forEach(() => {
      subcount.push(0);
    })
    temp.splice(i + 1, 0, {
      count_add: 0,
      count_mon1: 0,
      count_mon2: 0,
      count_mon3: 0,
      count: 0,
      subcount: subcount,
      _status: 'new'
    });
    temp.forEach((x, i) => {
      x.i = i;
    })
    setSelectedGoods(temp);
  }

  const onDeleteGoods = (i) => {
    const avalidGoods = selectedGoods.filter(x => !x.deleted);
    if (avalidGoods.length === 1) {
      if (!avalidGoods[0].goods_spec_id) {
        return;
      }
    }

    Modal.confirm({
      title: '确定删除当前产品吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{selectedGoods[i].goods_spec_name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const temp = [].concat(selectedGoods);
        const subcount = [];
        temp[0].subcount.forEach(() => {
          subcount.push(0);
        })
        if (temp[i].id) {
          temp[i].deleted = true;
        } else {
          temp.splice(i, 1);
        }
        if (temp.filter(x => x.deleted !== true).length === 0) {
          temp.push({ count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, subcount: subcount, count: 0 });
        }
        temp.forEach((x, i) => {
          x.i = i;
        })
        setSelectedGoods(temp);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onShipWithSelectChange = (value) => {
    if (value && value.length > 0)
      setShippingWith(value.join(','));
    else
      setShippingWith(undefined);
  }

  useEffect(() => {
    if (selectedBuyerId) {
      getBuyerGoods();
    }
  }, [selectedBuyerId])

  useEffect(() => {
    const temp = selectedGoods.map(x => {
      const find = selectedBuyerGoods.find(y => y.goods_spec_id === x.goods_spec_id);
      if (find)
        return { ...x, pcs_per_carton: find.pcs_per_carton, carton_count_per_pallet: find.carton_count_per_pallet }
      else
        return x;
    });
    setSelectedGoods(temp);
  }, [selectedBuyerGoods])

  const onChangeBuyerId = (value) => {
    if (!value) return;

    setSelectedBuyerId(value);
    const selectedBuyer = buyers.find(x => x.id === value) || {};
    const goodsCodes = (selectedBuyer.goods_code || '').split(',').filter(x => x.length > 0);
    if (goodsCodes.length === 1) {
      setGoodsCode(goodsCodes[0]);
    } else {
      setGoodsCode(undefined);
    }
    getStatYear(value, new Date().getFullYear())
      .then(data => {
        if (data) {
          setBuyerStatYear(data);
        }
        else setBuyerStatYear({ pending: 0, completed: 0, amount: 0 })
      });
    setSelectedPaymentId(selectedBuyer.payment_id);
    setSelectedDestinationPortId(selectedBuyer.port_id);
    setSelectedOwnerId(selectedBuyer.owner_id);
    setShippingWith(undefined);
    setSelectedGoods([{ i: 0, count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, count: 0 }]);
  }

  useEffect(() => {
    if (mode === 'edit') {
      setReadonly(true);
      getStatYear(order.buyer_id, new Date().getFullYear())
        .then(data => {
          if (data) {
            setBuyerStatYear(data);
          }
          else setBuyerStatYear({ pending: 0, completed: 0, amount: 0 })
        });
      getListOrderGoods(order.id).then(data => {
        if (data.length === 0) {
          data.push({ count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, count: 0 });
        }
        data.forEach((x, i) => {
          x.i = i;
        })
        setSelectedGoods(data)
        if (data.length > 200) {
          const temp = Object.assign(pagination);
          if (temp.limit < 20) {
            setPagination({ limit: 20, offset: page * 20 });
          }
        }
      })
    } else {
      getDatetime().then(data => setOrderDatetime(data));
    }
  }, []);

  const merge = () => {
    let temp = [].concat(selectedGoods);
    for (let i = 0; i < temp.length; i++) {
      for (let j = i + 1; j < temp.length; j++) {
        if (temp[i].deleted) continue;
        if (temp[i].goods_spec_id) {
          if (temp[i].goods_spec_id === temp[j].goods_spec_id) {
            temp[i].count += temp[j].count;
            temp[i].count_add += temp[j].count_add;
            temp[i].count_mon1 += temp[j].count_mon1;
            temp[i].count_mon2 += temp[j].count_mon2;
            temp[i].count_mon3 += temp[j].count_mon3;
            temp[j].count = 0;
            temp[j].count_add = 0;
            temp[j].count_mon1 = 0;
            temp[j].count_mon2 = 0;
            temp[j].count_mon3 = 0;
            temp[i].subcount.forEach((x, ii) => {
              temp[i].subcount[ii] += temp[j].subcount[ii];
              temp[j].subcount[ii] = 0;
            });
            temp[j].deleted = true;
          }
        } else {
          temp[i].count = 0;
          temp[i].count_add = 0;
          temp[i].count_mon1 = 0;
          temp[i].count_mon2 = 0;
          temp[i].count_mon3 = 0;
          temp[i].subcount.forEach((x, ii) => {
            temp[i].subcount[ii] = 0;
          });
          temp[i].deleted = true;
        }
        if (!temp[j].goods_spec_id) {
          temp[j].count = 0;
          temp[j].count_add = 0;
          temp[j].count_mon1 = 0;
          temp[j].count_mon2 = 0;
          temp[j].count_mon3 = 0;
          temp[j].subcount.forEach((x, ii) => {
            temp[j].subcount[ii] = 0;
          });
          temp[j].deleted = true;
        }
      }
    }
    temp = temp.filter(x => x.count > 0 || (x.deleted && x.id));
    if (temp.length === 0) {
      temp.push({ count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, count: 0 });
    }
    temp.forEach((x, i) => {
      x.i = i;
    })
    setSelectedGoods(temp);
    setPage(0);
  }

  const reset = () => {
    const temp = orderGoods.length === 0 ? [{ i: 0, count_add: 0, count_mon1: 0, count_mon2: 0, count_mon3: 0, count: 0 }] : JSON.parse(JSON.stringify(orderGoods));
    Modal.confirm({
      title: '确定重置到初始状态吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{temp.filter(x => x.goods_spec_id).length}条数据</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        setSelectedGoods(temp);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const onSave = async () => {
    const values = await form.validateFields();
    values.delivery_deadline_date = moment(values.period[1]).format("YYYY-MM-DD");
    values.date = moment(values.period[0]).format("YYYY-MM-DD");
    values.creater_id = currentUser.id;
    values.is_asap = isAsap;
    values.is_pre_add = isPreAdd;
    values.jidu_year = jiduYear;
    values.header_desc = headerDesc || '';
    values.footer_desc = footerDesc || '';
    values.goods_code = goodsCode || '';
    const find = currency_rate.find(x => x.name === '美元');
    if (find && find.rate5) {
      values.currency_rate = find.rate5;
    } else {
      values.currency_rate = 1.0;
    }

    if (values.is_shipwith && shippingWith) {
      values.shipwith = shippingWith;
    }
    // if (values.delivery_deadline_date <= values.date) {
    //   Modal.error({
    //     title: '日期错误',
    //     content: '交货期限必须晚于订单签订日期！',
    //   });
    //   return;
    // }
    const validGoods = [];
    //merge();
    const tempGoods = JSON.parse(JSON.stringify(selectedGoods));
    for (let i = 0; i < tempGoods.length; i++) {
      const temp = tempGoods[i];
      if (mode === 'new' && type === 1) {
        temp.subcount = [temp.count];
      } else if (mode === 'new' && type !== 1) {
        temp.subcount = [];
      }
      if (!isPreAdd) temp.count_add = 0;
      if (temp.goods_spec_id && !temp.deleted) {
        if (!checkCount(temp)) {
          Modal.error({
            title: '产品数量错误',
            content: '该订单中存在 [采购总数] 不等于 [每月采购] 之和！',
          });
          return;
        }
      }
      if (temp.goods_spec_id && temp.count) {
        validGoods.push(temp);
      } else {
        temp.deleted = true;
      }
    }
    if (validGoods.length === 0 || validGoods.filter(x => !x.price) > 0) {
      Modal.error({
        title: '订单产品',
        content: '该订单中无有效产品，请确认产品名称、产品号、单价、数量！',
      });
      return;
    }

    const data = {
      id: order && order.id,
      order: values,
      insert_goods: validGoods.filter(x => !x.id && !x.deleted),
      update_goods: validGoods.filter(x => x.id && !x.deleted),
      delete_goods: tempGoods.filter(x => x.id && x.deleted).map(y => ({ id: y.id }))
    }
    if (onSaveCallback) {
      onSaveCallback(data, () => { });
    }
    setReadonly(true);
  }

  const arrTemp = [];
  const filteredGoods = [];//获取name值
  selectedBuyerGoods.forEach(res => {
    if (!arrTemp.includes(res.goods_id)) {
      filteredGoods.push({ id: res.goods_id, name: res.goods_name });
      arrTemp.push(res.goods_id);
    }
  })

  const goods_footer_jidu = (total) => {
    if (type === 21 || type === 22 || type === 23 || type === 24) {
      return [
        isPreAdd && <td className="td" align="right"><strong>{toThousands(total.count_add)}</strong></td>,
        <td className="td" align="right"><strong>{toThousands(total.count_mon1)}</strong></td>,
        <td className="td" align="right"><strong>{toThousands(total.count_mon2)}</strong></td>,
        <td className="td" align="right"><strong>{toThousands(total.count_mon3)}</strong></td>,
      ];
    }
  }

  const goods_footer_add = (total) => {
    if (type === 1 && total.subcount.length < 2) return undefined;
    return total.subcount.map(x => {
      return <td className="td" align="right"><strong>{x}</strong></td>
    });
  }

  const goods_name_footer = () => {
    const temp = selectedGoods[0].subcount || [];
    if (type === 1) {
      if (temp.length > 3) {
        return 0;
      }
    } else {
      //if (temp.length > 0) {
      return 0;
      //}
    }
    return 1;
  }
  const goods_name_header = () => {
    const temp = selectedGoods[0].subcount || [];
    if (type === 1) {
      if (temp.length > 3) {
        return undefined;
      }
    } else {
      //if (temp.length > 0) {
      return undefined;
      //}
    }
    return <th width="175px" className="th" rowSpan={2}>产品名称</th>;
  }
  const goods_name_rows = (good) => {
    const temp = selectedGoods[0].subcount || [];
    if (type === 1) {
      if (temp.length > 3) {
        return undefined;
      }
    } else {
      // if (temp.length > 0) {
      return undefined;
      //}
    }
    return <td className="td">{good.goods_name}&nbsp;{good._status === 'new' && mode === 'edit' ? <Tag color="#87d068">new</Tag> : undefined}</td>;
  }

  const goods_header_add = () => {
    const arr = [];
    const temp = selectedGoods[0].subcount || [];
    if (type === 1) {
      if (temp.length > 1)
        temp.forEach((x, i) => {
          if (i === 0) {
            arr.push(<th width="70px" className="th" rowSpan={2}>初始</th>);
          } else {
            arr.push(<th width="70px" className="th" rowSpan={2}>追加{i}<sup><CloseOutlined hidden={isReadonly} onClick={() => deleteAddCol(i)} style={{ color: 'red' }} /></sup></th>);
          }
        });
    } else {
      temp.forEach((x, i) => {
        arr.push(<th width="70px" className="th" rowSpan={2}>追加{i + 1}<sup><CloseOutlined hidden={isReadonly} onClick={() => deleteAddCol(i)} style={{ color: 'red' }} /></sup></th>);
      });
    }
    return arr;
  }

  const goods_header_jidu = () => {
    const arr = [];
    if (isPreAdd) {
      arr.push(<th width="70px" className="th" rowSpan={2}>上季追加</th>);
    }
    if (type === 21) {
      return arr.concat([
        <th width="70px" className="th" rowSpan={2}>1月</th>,
        <th width="70px" className="th" rowSpan={2}>2月</th>,
        <th width="70px" className="th" rowSpan={2}>3月</th>
      ])
    } else if (type === 22) {
      return arr.concat([
        <th width="70px" className="th" rowSpan={2}>4月</th>,
        <th width="70px" className="th" rowSpan={2}>5月</th>,
        <th width="70px" className="th" rowSpan={2}>6月</th>
      ])
    } else if (type === 23) {
      return arr.concat([
        <th width="70px" className="th" rowSpan={2}>7月</th>,
        <th width="70px" className="th" rowSpan={2}>8月</th>,
        <th width="70px" className="th" rowSpan={2}>9月</th>
      ])
    } else if (type === 24) {
      return arr.concat([
        <th width="70px" className="th" rowSpan={2}>10月</th>,
        <th width="70px" className="th" rowSpan={2}>11月</th>,
        <th width="70px" className="th" rowSpan={2}>12月</th>
      ])
    }
  }

  const goods_rows_add = (i, good) => {
    const arr = [];
    const temp = good.subcount || [];
    if (type === 1 && temp.length < 2) return undefined;
    temp.forEach((x, ii) => {
      arr.push(
        <td className="td">
          <InputNumber
            id={'oadd' + ii + '-' + i}
            onFocus={() => setCurrentRowIndex(i)}
            keyboard={false}
            onKeyDown={(e) => onKeyDown(e)}
            onKeyUp={(e) => onKeyUp(e)}
            onPressEnter={(e) => onPressEnter(e)}
            disabled={isReadonly}
            onChange={(value) => onGoodsChangeSubCount(value, i, ii)}
            style={{ backgroundColor: '#FFD700', width: '100%' }}
            size="small"
            min={0} value={x > 0 ? x : undefined} />
        </td>
      );
    });
    return arr;
  }

  const goods_rows_jidu = (i, good) => {
    const arr = [];
    if (type === 21 || type === 22 || type === 23 || type === 24) {
      if (isPreAdd) {
        arr.push(
          <td className="td">
            <Tooltip title={good.error0}>
              <InputNumber
                id={'on1-' + i}
                onFocus={() => setCurrentRowIndex(i)}
                keyboard={false}
                onKeyDown={(e) => onKeyDown(e)}
                onKeyUp={(e) => onKeyUp(e)}
                onPressEnter={(e) => onPressEnter(e)}
                disabled={isReadonly}
                onChange={(value) => onGoodsChangeCountAdd(value, i)}
                style={{ backgroundColor: backgroundColor2(good, good.count_add, 0), width: '100%' }}
                size="small"
                min={0} value={good.count_add > 0 ? good.count_add : undefined} />
            </Tooltip>
          </td>
        );
      }
      arr.push(
        <td className="td">
          <Tooltip title={good.error1}>
            <InputNumber
              id={'on2-' + i}
              onFocus={() => setCurrentRowIndex(i)}
              keyboard={false}
              onKeyDown={(e) => onKeyDown(e)}
              onKeyUp={(e) => onKeyUp(e)}
              onPressEnter={(e) => onPressEnter(e)}
              disabled={isReadonly}
              onChange={(value) => onGoodsChangeCountMon1(value, i)}
              style={{ backgroundColor: backgroundColor2(good, good.count_mon1, 1), width: '100%' }}
              size="small"
              min={0} value={good.count_mon1 > 0 ? good.count_mon1 : undefined} />
          </Tooltip>
        </td>
      );
      arr.push(
        <td className="td">
          <Tooltip title={good.error2}>
            <InputNumber
              id={'on3-' + i}
              onFocus={() => setCurrentRowIndex(i)}
              keyboard={false}
              onKeyDown={(e) => onKeyDown(e)}
              onKeyUp={(e) => onKeyUp(e)}
              onPressEnter={(e) => onPressEnter(e)}
              disabled={isReadonly}
              onChange={(value) => onGoodsChangeCountMon2(value, i)}
              style={{ backgroundColor: backgroundColor2(good, good.count_mon2, 2), width: '100%' }}
              size="small"
              min={0} value={good.count_mon2 > 0 ? good.count_mon2 : undefined} />
          </Tooltip>
        </td>
      );
      arr.push(
        <td className="td">
          <Tooltip title={good.error3}>
            <InputNumber
              id={'on4-' + i}
              onFocus={() => setCurrentRowIndex(i)}
              keyboard={false}
              onKeyDown={(e) => onKeyDown(e)}
              onKeyUp={(e) => onKeyUp(e)}
              onPressEnter={(e) => onPressEnter(e)}
              disabled={isReadonly}
              onChange={(value) => onGoodsChangeCountMon3(value, i)}
              style={{ backgroundColor: backgroundColor2(good, good.count_mon3, 3), width: '100%' }}
              size="small"
              min={0} value={good.count_mon3 > 0 ? good.count_mon3 : undefined} />
          </Tooltip>
        </td>
      );
    }
    return arr;
  }

  const goods_rows = () => {
    const arr = [];
    let showRows = 0;
    for (let i = pagination.offset; i < avalidGoods.length && showRows < pagination.limit; i++) {
      const good = avalidGoods[i];
      if (good.deleted) continue;
      const idx = good.i;
      showRows++;
      arr.push([
        <tr style={currentRowIndex === idx ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
          <td className="td">{page * pagination.limit + showRows}</td>
          <td className="td">
            <Select
              optionFilterProp="children"
              disabled={isReadonly}
              size="small"
              style={{ backgroundColor: '#FFD700', width: '100%' }}
              showSearch="true"
              placeholder="请选择产品号"
              value={[good.goods_spec_id]}
              onChange={(value) => onGoodsChangeSpec(value, idx)}
              onFocus={() => setCurrentRowIndex(idx)}
              onBlur={() => setCurrentRowIndex(idx)}
            >
              {selectedBuyerGoods.map(item => (
                <Select.Option key={item.goods_spec_id} value={item.goods_spec_id}>
                  {item.goods_spec_name}
                </Select.Option>
              ))}
            </Select></td>
          {goods_name_rows(good)}
          <td className="td">{good.size}</td>
          <td className="td" align="right">{good.price}{editPrice(good)}</td>
          {goods_rows_jidu(idx, good)}
          {goods_rows_add(idx, good)}
          <td className="td">
            <Tooltip title={good.error}>
              <InputNumber
                id={'on-' + idx}
                onFocus={() => setCurrentRowIndex(idx)}
                keyboard={false}
                onKeyDown={(e) => onKeyDown(e)}
                onKeyUp={(e) => onKeyUp(e)}
                onPressEnter={(e) => onPressEnter(e)}
                disabled={isReadonly}
                onChange={(value) => onGoodsChangeCount(value, idx)}
                style={{ backgroundColor: backgroundColor(good), width: '100%' }}
                size="small"
                min={0} value={good.count > 0 ? good.count : undefined} />

            </Tooltip>
          </td>
          <td className="td">{toFixed2((good.count * 1.0 / good.pcs_per_carton) / good.carton_count_per_pallet, 2)}</td>
          <td className="td" align="right">{toThousands(toFixed2(good.count * good.price, 4))}</td>
          <td className="td">
            <Input
              id={'or-' + idx}
              onFocus={() => setCurrentRowIndex(idx)}
              onKeyDown={(e) => onKeyDown(e)}
              onKeyUp={(e) => onKeyUp(e, idx)}
              onPressEnter={(e) => onPressEnter(e)}
              disabled={isReadonly}
              value={good.remark}
              onChange={(e) => onGoodsChangeRemark(e.target.value, idx)}
              style={{ backgroundColor: '#FFD700' }}
              size="small" /></td>
          <td><Button disabled={isReadonly} onClick={() => onDeleteGoods(idx)} type="link" danger size="small" icon={<DeleteOutlined />} />
            <Button disabled={isReadonly} onClick={() => onAddGoods(idx)} type="link" size="small" icon={<PlusCircleOutlined />} /></td>
        </tr>
      ]);
    }

    return arr;
  }

  const sum = {
    count_add: 0,
    count_mon1: 0,
    count_mon2: 0,
    count_mon3: 0,
    subcount: [],
    count: 0,
    amount: 0
  };
  for (let i = 0; i < avalidGoods.length; i++) {
    if (avalidGoods[i].count) {
      sum.count += avalidGoods[i].count;
      (avalidGoods[i].subcount || []).forEach((x, ii) => {
        if (!sum.subcount[ii]) sum.subcount[ii] = 0;
        sum.subcount[ii] += x;
      });
      sum.count_add += avalidGoods[i].count_add;
      sum.count_mon1 += avalidGoods[i].count_mon1;
      sum.count_mon2 += avalidGoods[i].count_mon2;
      sum.count_mon3 += avalidGoods[i].count_mon3;
      sum.amount += avalidGoods[i].count * avalidGoods[i].price;
    }
  }

  const initValue = [
    { name: ['id'], value: order && order.id },
    { name: ['buyer_id'], value: selectedBuyerId },
    { name: ['payment_id'], value: selectedPaymentId },
    { name: ['owner_id'], value: selectedOwnerId },
    { name: ['shipmark'], value: shippingMark },
    { name: ['destination_port_id'], value: selectedDestinationPortId },
    { name: ['po_code'], value: poCode },
    { name: ['period'], value: period },
    { name: ['remark'], value: remark },
    { name: ['header_desc'], value: headerDesc },
    { name: ['footer_desc'], value: footerDesc },
    { name: ['company_id'], value: selectedCompanyId },
    { name: ['loading_port_id'], value: selectedLoadingPortId },
    { name: ['transport_id'], value: transportId },
    { name: ['type'], value: type },
    { name: ['goods_code'], value: goodsCode },
  ];

  const filterStatData = () => {
    const data = Object.assign({}, buyerStatYear);
    if (mode === 'edit') {
      if (data) {
        if (order.delivery_date) {
          if (data.completed > 0) {
            data.completed -= 1;
            data.completed_no = data.completed_no.replace(order.no + ',', '');
            data.completed_no = data.completed_no.replace(',' + order.no, '');
            data.completed_no = data.completed_no.replace(order.no, '');
          }
        } else {
          if (data.pending > 0) {
            data.pending -= 1;
            data.pending_no = data.pending_no.replace(order.no + ',', '');
            data.pending_no = data.pending_no.replace(',' + order.no, '');
            data.pending_no = data.pending_no.replace(order.no, '');
          }
        }
      }
    }
    return data;
  }


  const renderPage = () => {
    const arr = [];
    const pageCount = Math.ceil(avalidGoods.length / pagination.limit);
    arr.push(<span>共<strong>{avalidGoods.filter(x => x.goods_spec_id).length}</strong>条数据</span>);
    if (avalidGoods.length > 10) {
      arr.push(<span style={{ marginRight: '1.5rem' }}>,&nbsp;每页&nbsp;<Select
        onChange={onChangePagination} value={pagination.limit}
        size="small">
        <Select.Option value={10}>10</Select.Option>
        {avalidGoods.length > 10 && <Select.Option value={20}>20</Select.Option>}
        {avalidGoods.length > 20 && <Select.Option value={30}>30</Select.Option>}
        {avalidGoods.length > 30 && <Select.Option value={50}>50</Select.Option>}
        {avalidGoods.length > 50 && <Select.Option value={100}>100</Select.Option>}
      </Select>&nbsp;条</span>)
    }
    if (pageCount <= 1) {
      return arr;
    }
    if (pageCount > 4) {
      arr.push(<Button size="small" disabled={page === 0} onClick={onPrePage} type="link" icon={<LeftOutlined />}></Button>);
    }
    for (let i = 0; i < pageCount; i++) {
      if (page === i) {
        arr.push(<Button size="small">{i + 1}</Button>)
      } else {
        arr.push(<Button onClick={() => setPage(i)} size="small" type="link">{i + 1}</Button>)
      }
    }
    if (pageCount > 4) {
      arr.push(<Button size="small" disabled={page === pageCount - 1} onClick={onNextPage} type="link" icon={<RightOutlined />}></Button>);
    }
    return arr;
  }

  const addButtons = () => {
    if (mode === 'new') return undefined;
    return <Dropdown disabled={isReadonly || !selectedBuyerId} placement="bottomLeft" overlay={
      <Menu onClick={handleImport}>
        <Menu.Item icon={<FileExcelOutlined />} key={1} value={1}>模板导入追加</Menu.Item>
        <Menu.Item icon={<DatabaseOutlined />} key={2} value={2}>手动追加</Menu.Item>
      </Menu>
    } trigger={['click']}>
      <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
        订单追加&nbsp;<CaretDownOutlined />&nbsp;&nbsp;
      </a>
    </Dropdown>
  }

  const statData = filterStatData();
  return (
    <Form form={form} preserve={false} onFinish={onSave} fields={initValue} >
      <Row style={{ height: '100%', flexFlow: 'nowrap' }}>
        <Col flex="340px" className="order-new-left-panel">
          <Row>
            <Col span={24}>
              <Form.Item label="业务公司" name="company_id" rules={[{ required: true, message: '请选择业务公司!' }]}                            >
                <Select
                  onChange={(value) => setSelectedCompanyId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  disabled={isReadonly}
                  placeholder="请选择业务公司" >
                  {company.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name_cn}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{ paddingRight: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Form.Item label="订单类型" name="type" rules={[{ required: true, message: '请选择订单类型!' }]}>
                  <Select
                    optionFilterProp="children"
                    onChange={(value) => setType(value)}
                    disabled={isReadonly}
                    style={{ width: '140px' }}
                    onFocus={console.log('onFocus')}
                    onBlur={console.log('onBlur')}
                    placeholder="请选择订单类型">
                    <Select.Option key={1} value={1}>
                      普通订单
                    </Select.Option>
                    <Select.Option key={21} value={21}>
                      季度单 [1季度]
                    </Select.Option>
                    <Select.Option key={22} value={22}>
                      季度单 [2季度]
                    </Select.Option>
                    <Select.Option key={23} value={23}>
                      季度单 [3季度]
                    </Select.Option>
                    <Select.Option key={24} value={24}>
                      季度单 [4季度]
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Select disabled={isReadonly || type === 1} value={type === 1 ? undefined : jiduYear} onChange={setJiduYear} style={{ width: '80px' }}>
                  <Select.Option key={0} value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</Select.Option>
                  <Select.Option key={1} value={new Date().getFullYear()}>{new Date().getFullYear()}</Select.Option>
                  <Select.Option key={2} value={new Date().getFullYear() + 1}>{new Date().getFullYear() + 1}</Select.Option>
                </Select>
              </div>
            </Col>
          </Row>
          <Row>
            <div style={{ width: '100%', textAlign: 'right' }} >
              <div style={{ paddingRight: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Form.Item label="客户名称" name="buyer_id" rules={[{ required: true, message: '请选择订单客户!' }]}>
                  <Select
                    optionFilterProp="children"
                    onChange={(value) => onChangeBuyerId(value)}
                    disabled={isReadonly || (mode !== 'new' && order.status !== 2)}
                    showSearch="true"
                    style={{ width: '160px', textAlign: 'left' }}
                    onFocus={console.log('onFocus')}
                    onBlur={console.log('onBlur')}
                    placeholder="请选择买方客户">
                    {buyers.map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name_en}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Select allowClear value={goodsCode} disabled={isReadonly} onChange={setGoodsCode} style={{ textAlign: 'left', padding: '0', width: '62px' }}>
                  {
                    (selectedBuyer.goods_code || '').split(',').filter(x => x.length > 0).map(x => {
                      return <Select.Option key={x} value={x}>{x}</Select.Option>
                    })
                  }
                </Select>
              </div>
              <div style={{ display: 'inline-flex' }}>
                {buyerStatYear.pending_no ? <Popover content={<p>
                  {
                    buyerStatYear.pending_no.split(',').map(x => <div>{x}</div>)
                  }
                </p>} title="进行中订单">
                  <Button type="link" size="small">进行中订单 ({buyerStatYear.pending})</Button>
                </Popover> :
                  <Button type="link" size="small">进行中订单 ({buyerStatYear.pending})</Button>
                }
                {buyerStatYear.completed_no ? <Popover content={<p>
                  {
                    buyerStatYear.completed_no.split(',').map(x => <div>{x}</div>)
                  }
                </p>} title="当年已成订单">
                  <Button type="link" size="small">当年已完成订单 ({buyerStatYear.completed})</Button>
                </Popover> :
                  <Button type="link" size="small">当年已完成订单 ({buyerStatYear.completed})</Button>
                }
                {/* <Button type="link" size="small">当年订单金额 ({buyerStatYear.amount})</Button> */}
              </div>
            </div>
          </Row>
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Row>
            <Col span={24}>
              <Form.Item label="ＰＯ编码" name="po_code" rules={[{ required: true, message: '请输入PO编码!' }]}                            >
                <Input style={{ width: '100%' }} onChange={(e) => setPoCode(e.target.value)} allowClear autocomplete="off" disabled={isReadonly} placeholder="请输入PO编码" />
              </Form.Item>

            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{ width: '100%', padding: '0 0 0.5rem 0', textAlign: 'right' }}>
                <Form.Item label="订单周期" name="period" rules={[{ required: true, message: '请选择订单周期!' }]}                            >
                  <RangePicker allowClear={false} allowEmpty={[false, false]} style={{ width: '100%' }} onChange={setPeriod} format="YYYY-MM-DD" disabled={isReadonly} inputReadOnly={isReadonly} />
                </Form.Item>
                <Checkbox disabled={isReadonly} checked={isAsap} onChange={(e) => setAsap(e.target.checked)} style={{ marginRight: '79px' }}>ASAP</Checkbox>
                <Tag style={{ width: '92px', marginRight: '12px' }} color="#f50">周期: <strong>{period[0] && period[1] ? period[1].diff(period[0], 'day') : 'N/A'}</strong> 天</Tag>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="发货港口" name="loading_port_id" rules={[{ required: true, message: '请选择发货港口!' }]}                            >
                <Select
                  onChange={(value) => setSelectedLoadingPortId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  disabled={isReadonly}
                  showSearch="true"
                  optionFilterProp="children"
                  placeholder="请选择发货港口" >
                  {port.filter(x => x.country_id === 1).map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name_en} ${item.name_cn}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="到货港口" name="destination_port_id" rules={[{ required: true, message: '请选择到货港口!' }]}                            >
                <Select
                  onChange={(value) => setSelectedDestinationPortId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  disabled={isReadonly}
                  showSearch="true"
                  optionFilterProp="children"
                  placeholder="请选择到货港口" >
                  {port.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name_en} ${item.name_cn}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="运输条款" name="transport_id" rules={[{ required: true, message: '请选择运输条款!' }]}                            >
                <Select
                  onChange={(value) => setTransportId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  disabled={isReadonly}
                  showSearch="true"
                  optionFilterProp="children"
                  placeholder="请选择运输条款" >
                  {transport.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="支付方式" name="payment_id" rules={[{ required: true, message: '请选择支付方式!' }]}                            >
                <Select
                  onChange={(value) => setSelectedPaymentId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  disabled={isReadonly}
                  placeholder="请选择支付方式">
                  {payment.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name_en} ${item.name_cn}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="主业务员" name="owner_id" rules={[{ required: true, message: '请选择所属业务员!' }]}                            >
                <Select
                  optionFilterProp="children"
                  disabled={isReadonly}
                  showSearch="true"
                  placeholder="请选择所属业务员"
                  onChange={(value) => setSelectedOwnerId(value)}
                  onFocus={console.log('onFocus')}
                  onBlur={console.log('onBlur')}
                  style={{ width: '100%' }}
                >
                  {user.filter(x => x.category_id < 3).map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="唛头格式" name="shipmark" rules={[{ required: true, message: '请选择唛头格式!' }]}                            >
                <Input.TextArea
                  onChange={(e) => setShippingMark(e.target.value)}
                  disabled={isReadonly}
                  style={{ fontSize: '1.1rem', whiteSpace: 'pre-line' }}
                  value={shippingMark}
                  placeholder="请输入唛头"
                  autoSize={{ minRows: 4, maxRows: 4 }}
                />
              </Form.Item>
              <div style={{ padding: '0 0 0 7rem' }}>
                <Button onClick={() => setShippingMark(shipmark[0].name)} disabled={isReadonly} value="1" type="link" size="small">样式1</Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="remark" label="　 备 　 注" >
                <Input.TextArea
                  onChange={(e) => setRemark(e.target.value)}
                  disabled={isReadonly}
                  placeholder="请输入备注"
                  autoSize={{ minRows: 1, maxRows: 2 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="header_desc" label="回单附加-1" >
                <Input.TextArea
                  onChange={(e) => setHeaderDesc(e.target.value)}
                  disabled={isReadonly}
                  placeholder="请输入回单头部描述"
                  autoSize={{ minRows: 2, maxRows: 2 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="footer_desc" label="回单附加-2" >
                <Input.TextArea
                  onChange={(e) => setFooterDesc(e.target.value)}
                  disabled={isReadonly}
                  placeholder="请输入回单底部描述"
                  autoSize={{ minRows: 2, maxRows: 2 }}
                />
              </Form.Item>
            </Col>
          </Row>

        </Col>
        <Col flex="calc(100% - 400px)" style={{ padding: '1rem 1rem 5rem 1rem' }}>
          <div style={{ display: 'flex', padding: '0.25rem 0 0.5rem 0', justifyContent: 'space-between' }}>
            <div>
              {
                renderPage()
              }
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {addButtons()}
              <Button disabled={isReadonly || !selectedBuyerId} onClick={() => handleImport({ key: 0 })} type="link" size="small">{mode !== 'new' ? '重新' : '客户模板'}导入</Button>
              <Button disabled={isReadonly} type="link" onClick={merge} size="small">查重/合并</Button>
              <Button disabled={isReadonly} type="link" onClick={reset} size="small">重置</Button>
            </div>
          </div>
          <table className="goods_table" border="1">
            <thead>
              <tr>
                <th className="th" width="42px" rowSpan={2}>#</th>
                <th width="150px" className="th" rowSpan={2}>产品号</th>
                {goods_name_header()}
                <th width="145px" className="th" rowSpan={2}>尺寸</th>
                <th width="70px" className="th" rowSpan={2}>单价({(currency.find(x => x.id === selectedBuyer.currency_id) || {}).symbol})</th>
                {goods_header_jidu()}
                {goods_header_add()}
                <th width="100px" className="th" rowSpan={2}>总数量(件)</th>
                <th width="60px" className="th">托数</th>
                <th width="100px" className="th" rowSpan={2}>金额({(currency.find(x => x.id === selectedBuyer.currency_id) || {}).symbol})</th>
                <th className="th" rowSpan={2}>备注</th>
                <th width="52px" rowSpan={2}></th>
              </tr>
            </thead>
            <tbody>
              {useMemo(() => goods_rows(), [
                isPreAdd, type, selectedBuyerId, selectedBuyerGoods, selectedGoods, isReadonly, currentRowIndex, page, pagination
              ])}
            </tbody>
            {
              selectedGoods.length > 0 &&
              <tfoot>
                <tr>
                  <td className="td" align="right" colspan={4 + goods_name_footer()}><strong>合计</strong></td>
                  {goods_footer_jidu(sum)}
                  {goods_footer_add(sum)}
                  <td className="td" align="right"><strong>{toThousands(sum.count)}</strong></td>
                  <td className="td" align="right"><strong>{toThousands(toFixed2(sum.amount, 4))}</strong></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            }
          </table>
          <Divider style={{ margin: '0' }} />
          <div className="page-footer">
            <div style={{ display: 'flex' }}>
              {type !== 1 && <Checkbox disabled={isReadonly} checked={isPreAdd} onChange={(e) => setPreAdd(e.target.checked)}><strong>上季度是否有追加？</strong></Checkbox>}
            </div>
            <Space size="large">
              {
                isReadonly &&
                <Dropdown placement="bottomLeft" overlay={downloadMenu} trigger={['click']}>
                  <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <DownloadOutlined /> &nbsp;下载客户回单<CaretDownOutlined />
                  </a>
                </Dropdown>
              }
              <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
              {
                !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button htmlType="submit" type="primary" icon={<SaveOutlined />}>保 存</Button>
                </div>
              }
              {
                isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button onClick={() => setReadonly(false)} type="primary" icon={<FormOutlined />}>编 辑</Button>
                </div>
              }
            </Space>
          </div>
        </Col>
      </Row>
      <Page
        title={`${importMode === 0 ? '客户订单导入' : '客户产品追加'} [${selectedBuyer.name_en}]`}
        isMaximize={true}
        body={<GoodsImport
          isPreAdd={isPreAdd}
          importMode={importMode}
          type={type}
          buyerId={selectedBuyer.id}
          buyerGoodsCode={goodsCode}
          orderDatetime={orderDatetime}
          buyerGoods={selectedBuyerGoods}
          getBuyerGoods={getBuyerGoods}
          onImportOrderGoods={onImportOrderGoods}
          onCloseCallback={() => setShowGoodsImport(false)}
        />}
        onCloseCallback={() => setShowGoodsImport(false)}
        visible={isShowGoodsImport}
      />
      <Page
        title={`修改客户价格[${selectedEditPriceGoods.goods_name}-${selectedEditPriceGoods.goods_spec_name}]`}
        width="620px"
        onCloseCallback={() => setShowEditPrice(false)}
        body={editPriceBody()}
        visible={isShowEditPrice}
      />
    </Form >)
});
